<template>
	  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
		      <path d="M14 4h-4v5H7l5 5 5-5h-3zM9 19c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2H9v2z"/>
		        </svg>
</template>
